import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default function css() {
  return null;
}
